import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { CallCenterTourStep } from "./entity";

const createCustomFilter = createCustomFilterForEntity<CallCenterTourStep>();

export class CallCenterTourStepFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<CallCenterTourStep>
  >((filters) => {
    return filterWithRelationsAndJson(CallCenterTourStep)(filters);
  });
}
